var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showProgress)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-progress-circular',_vm._g({attrs:{"rotate":360,"size":50,"width":5,"value":_vm.progress,"color":_vm.color}},on),[_vm._v(_vm._s((_vm.progress + "%")))])]}}],null,false,2991712284)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }